import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useTheme } from '../context/ThemeContext';
import BottomNav from './BottomNav';
import SidebarNav from './SidebarNav';
import useIsMobile from '../hooks/useIsMobile';

const API_URL = process.env.REACT_APP_API_URL || '';

export default function MusicianLayout({ children, title, scrollable = true }) {
  const theme = useTheme();
  const isMobile = useIsMobile(900);
  const [bandName, setBandName] = useState('');
  const [logoUrl, setLogoUrl] = useState('');

  useEffect(() => {
    axios.get(`${API_URL}/api/settings`)
      .then(res => {
        setBandName(res.data?.band_name || '');
        setLogoUrl(res.data?.logo_url || '');
      })
      .catch(() => {});
  }, []);

  if (!isMobile) {
    return (
      <div style={{
        display: 'flex',
        height: '100dvh',
        background: theme.background,
        overflow: 'hidden',
      }}>
        <SidebarNav bandName={bandName} logoUrl={logoUrl} />

        <div style={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
        }}>
          {title && (
            <div style={{
              flexShrink: 0,
              background: theme.navGradient,
            }}>
              <div style={{ padding: '12px 24px 16px' }}>
                <div style={{
                  fontSize: 22,
                  fontWeight: 700,
                  color: '#fff',
                  lineHeight: 1.2,
                }}>
                  {title}
                </div>
              </div>
            </div>
          )}

          <div style={{
            flex: 1,
            minHeight: 0,
            overflowY: scrollable ? 'auto' : 'hidden',
            WebkitOverflowScrolling: 'touch',
          }}>
            {children}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      height: '100dvh',
      background: theme.background,
      overflow: 'hidden',
    }}>
      {title && (
        <div style={{
          flexShrink: 0,
          background: theme.navGradient,
          padding: 'env(safe-area-inset-top) 0 0',
        }}>
          <div style={{ padding: '10px 16px 14px' }}>
            {bandName && (
              <div style={{
                fontSize: 11,
                fontFamily: 'monospace',
                color: 'rgba(255,255,255,0.7)',
                letterSpacing: '0.08em',
                marginBottom: 2,
              }}>
                {bandName.toUpperCase()}
              </div>
            )}
            <div style={{
              fontSize: 22,
              fontWeight: 700,
              color: '#fff',
              lineHeight: 1.2,
            }}>
              {title}
            </div>
          </div>
        </div>
      )}

      <div style={{
        flex: 1,
        minHeight: 0,
        overflowY: scrollable ? 'auto' : 'hidden',
        WebkitOverflowScrolling: 'touch',
      }}>
        {children}
      </div>

      <BottomNav />
    </div>
  );
}
